import React, { useEffect, useState } from 'react';

import {
  Container,
  TopMenu,
  Content,
  Main,
  ButtonMenu,
  LeftMenu,
  MainScroll,
  LeftModulo,
  ButtonModulo,
} from './styles';

import ModuloLista from './componentes/ModuloLista';
import MenuLista from './componentes/MenuLista';
import SubMenuLista from './componentes/SubMenuLista';

import Perfil from './componentes/Perfil';
import AvisoNovoPortal from '~/componentes/AvisoNovoPortal';

import LogoErpWorks from '~/assets/logos/Logo ErpWorks.svg';
import LogoErpWorksB from '~/assets/logos/Logo ErpWorks B.svg';

// import Notificacoes from "./componentes/Notificacoes";
// import Logout from "./componentes/Logout";
// import Modal from "~/componentes/Modal";
// import LeaveSystem from "./componentes/LeaveSystem";
import sistemaStore from './sistemaStore';
import useMenuHandler from './sistemaHooks/useMenuHandler';
import api from '~/services/api';

export default function Sistema() {
  const [showLateralMenu, setShowLateralMenu] = useState();
  const [showMaxMenu, setShowMaxMenu] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showMenuWithSubMenu, setShowMenuWithSubMenu] = useState();
  const [showSubMenuRight, setShowSubMenuRight] = useState(false);
  const [showMenuWithSubMenuRight, setShowMenuWithSubMenuRight] = useState();
  const [showModulo, setShowModulo] = useState(false);
  const [ativaAnterior, setAtivaAnterior] = useState(true);
  const [ativaProximo, setAtivaProximo] = useState(true);
  const [modulosAcessoLeft, setModulosAcessoLeft] = useState([]);
  const [modulosAcessoTop, setModulosAcessoTop] = useState([]);
  const [hasUnreadComunicados, setHasUnreadComunicados] = useState(false);
  const {
    desktop,
    modulosAcesso,
    componentPath,
    setComponentPath,
    RenderedComponent,
    currentModulo,
    currentMenu,
    currentSubMenu,
    perfil,
  } = useMenuHandler({ setShowLateralMenu });

  useEffect(() => {
    let modulosLeft = [];
    let modulosTop = [];
    for (let item of modulosAcesso) {
      if (item?.tipoMenu === 'LEFT') modulosLeft.push(item);
      else if (item?.tipoMenu === 'TOP') modulosTop.push(item);
    }

    setModulosAcessoLeft(modulosLeft);
    setModulosAcessoTop(modulosTop);
  }, [modulosAcesso]);

  // Verificar comunicados não lidos
  useEffect(() => {
    async function checkUnreadComunicados() {
      try {
        const response = await api.get('/signed/empresa/gestorprojeto/comunicado/ativos');
        if (response?.status === 200 && Array.isArray(response?.data)) {
          const hasUnread = response.data.some(c => !c.lido);
          setHasUnreadComunicados(hasUnread);
        }
      } catch (error) {
        console.warn('Erro ao verificar comunicados:', error);
      }
    }

    checkUnreadComunicados();
    // Verificar a cada 5 minutos
    const interval = setInterval(checkUnreadComunicados, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (currentModulo?.tipoMenu === 'TOP') {
      setShowMenu(false);
    } else if (currentModulo?.tipoMenu === 'LEFT') {
      setShowMenu(true);
    }
  }, [currentModulo]);

  function proximo() {
    let modulo = currentModulo;
    let menu = currentMenu;
    let subMenu = currentSubMenu;
    if (menu?.possuiSubMenu) {
      let indexSubMenu = menu?.subMenus?.findIndex(e => e?.id === subMenu?.id);
      if (menu?.subMenus[indexSubMenu + 1]) {
        let thisSubMenu = menu?.subMenus[indexSubMenu + 1];
        if (menu?.subMenus[indexSubMenu + 2]) {
          setAtivaAnterior(true);
          setAtivaProximo(true);
        } else {
          let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
          if (modulo?.menus[indexMenu + 1]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            setAtivaAnterior(true);
            setAtivaProximo(false);
          }
        }
        setComponentPath({
          moduloPath: modulo?.path,
          menuPath: menu?.path,
          subMenuPath: thisSubMenu?.path,
        });
      } else {
        let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
        if (modulo?.menus[indexMenu + 1]) {
          let thisMenu = modulo?.menus[indexMenu + 1];
          if (thisMenu?.possuiSubMenu) {
            let thisSubMenu = thisMenu?.subMenus?.[0];
            if (thisMenu?.subMenus?.[thisMenu?.subMenus?.length + 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              if (modulo?.menus[indexMenu + 2]) {
                setAtivaAnterior(true);
                setAtivaProximo(true);
              } else {
                setAtivaAnterior(true);
                setAtivaProximo(false);
              }
            }
            setComponentPath({
              moduloPath: modulo?.path,
              menuPath: thisMenu?.path,
              subMenuPath: thisSubMenu?.path,
            });
          } else {
            if (modulo?.menus[indexMenu + 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              setAtivaAnterior(true);
              setAtivaProximo(false);
            }
            setComponentPath({
              moduloPath: modulo?.path,
              menuPath: thisMenu?.path,
              subMenuPath: false,
            });
          }
        }
      }
    } else {
      let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
      if (modulo?.menus[indexMenu + 1]) {
        let thisMenu = modulo?.menus[indexMenu + 1];
        if (thisMenu?.possuiSubMenu) {
          let thisSubMenu = thisMenu?.subMenus?.[0];
          if (thisMenu?.subMenus?.[thisMenu?.subMenus?.length + 2]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            if (modulo?.menus[indexMenu + 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              setAtivaAnterior(true);
              setAtivaProximo(false);
            }
          }
          setComponentPath({
            moduloPath: modulo?.path,
            menuPath: thisMenu?.path,
            subMenuPath: thisSubMenu?.path,
          });
        } else {
          if (modulo?.menus[indexMenu + 2]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            setAtivaAnterior(true);
            setAtivaProximo(false);
          }
          setComponentPath({
            moduloPath: modulo?.path,
            menuPath: thisMenu?.path,
            subMenuPath: false,
          });
        }
      }
    }
  }

  function anterior() {
    let modulo = currentModulo;
    let menu = currentMenu;
    let subMenu = currentSubMenu;
    if (menu?.possuiSubMenu) {
      let indexSubMenu = menu?.subMenus?.findIndex(e => e?.id === subMenu?.id);
      if (menu?.subMenus[indexSubMenu - 1]) {
        let thisSubMenu = menu?.subMenus[indexSubMenu - 1];
        if (menu?.subMenus[indexSubMenu - 2]) {
          setAtivaAnterior(true);
          setAtivaProximo(true);
        } else {
          let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
          if (modulo?.menus[indexMenu - 1]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            setAtivaAnterior(false);
            setAtivaProximo(true);
          }
        }
        setComponentPath({
          moduloPath: modulo?.path,
          menuPath: menu?.path,
          subMenuPath: thisSubMenu?.path,
        });
      } else {
        let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
        if (modulo?.menus[indexMenu - 1]) {
          let thisMenu = modulo?.menus[indexMenu - 1];
          if (thisMenu?.possuiSubMenu) {
            let thisSubMenu = thisMenu?.subMenus?.[thisMenu?.subMenus?.length - 1];
            if (thisMenu?.subMenus?.[thisMenu?.subMenus?.length - 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              if (modulo?.menus[indexMenu - 2]) {
                setAtivaAnterior(true);
                setAtivaProximo(true);
              } else {
                setAtivaAnterior(false);
                setAtivaProximo(true);
              }
            }
            setComponentPath({
              moduloPath: modulo?.path,
              menuPath: thisMenu?.path,
              subMenuPath: thisSubMenu?.path,
            });
          } else {
            if (modulo?.menus[indexMenu - 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              setAtivaAnterior(false);
              setAtivaProximo(true);
            }
            setComponentPath({
              moduloPath: modulo?.path,
              menuPath: thisMenu?.path,
              subMenuPath: false,
            });
          }
        }
      }
    } else {
      let indexMenu = modulo?.menus?.findIndex(e => e?.id === menu?.id);
      if (modulo?.menus[indexMenu - 1]) {
        let thisMenu = modulo?.menus[indexMenu - 1];
        if (thisMenu?.possuiSubMenu) {
          let thisSubMenu = thisMenu?.subMenus?.[thisMenu?.subMenus?.length - 1];
          if (thisMenu?.subMenus?.[thisMenu?.subMenus?.length - 2]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            if (modulo?.menus[indexMenu - 2]) {
              setAtivaAnterior(true);
              setAtivaProximo(true);
            } else {
              setAtivaAnterior(false);
              setAtivaProximo(true);
            }
          }
          setComponentPath({
            moduloPath: modulo?.path,
            menuPath: thisMenu?.path,
            subMenuPath: thisSubMenu?.path,
          });
        } else {
          if (modulo?.menus[indexMenu - 2]) {
            setAtivaAnterior(true);
            setAtivaProximo(true);
          } else {
            setAtivaAnterior(false);
            setAtivaProximo(true);
          }
          setComponentPath({
            moduloPath: modulo?.path,
            menuPath: thisMenu?.path,
            subMenuPath: false,
          });
        }
      }
    }
  }

  return (
    <Container desktop={desktop}>
      <Content desktop={desktop}>
        <AvisoNovoPortal />
        <TopMenu
          desktop={desktop}
          widthSombra={'10.6rem' /*currentModulo?.menus?.length > 8 ? "10.6rem" : "4.8rem"*/}
        >
          <div className="sombra"></div>
          <div className="fundo-top">
            <div className="lateral-e">
              <div className="sec-logo">
                <img
                  className="logo"
                  src={localStorage.getItem('tema') == 'E' ? LogoErpWorks : LogoErpWorksB}
                  alt="Logo"
                />
              </div>
            </div>
            <div className="lateral-d">
              {/* <ButtonMenu>
                <img src={IconTopInicial} alt="Inicial" />
              </ButtonMenu> */}
              <ButtonMenu
                onClick={() => {
                  if (localStorage.getItem('tema')) {
                    if (localStorage.getItem('tema') == 'E') {
                      localStorage.setItem('tema', 'C');
                    } else {
                      localStorage.setItem('tema', 'E');
                    }
                  } else {
                    localStorage.setItem('tema', 'E');
                  }
                  window.location.reload();
                }}
              >
                <img
                  src={require('~/assets/icones/IconModo' +
                    (localStorage.getItem('tema') ? localStorage.getItem('tema') : 'C') +
                    '.svg')}
                  alt={'Tema'}
                />
              </ButtonMenu>
              {/* <ButtonMenu>
                <img src={IconTopNotificacao} alt="Notificação" />
              </ButtonMenu>
              <ButtonMenu>
                <img src={IconTopAgenda} alt="Agenda" />
              </ButtonMenu>
              <ButtonMenu>
                <img src={IconTopCompCliente} alt="Complemento do Cliente" />
              </ButtonMenu> */}
              <Perfil
                {...{
                  desktop,
                  perfilAtivo: perfil,
                  modulos: modulosAcessoLeft,
                  setComponentPath,
                  currentModulo,
                  showMaxMenu,
                  setShowMaxMenu,
                }}
              />
            </div>
          </div>
          {/* <div className="fundo-bottom">
            <div className="navigation-menu">
              <div className="nav" onClick={() => anterior()}>
                <img src={IconPrevAtivo} alt="Anterior" />
              </div>
              <div className="nav" onClick={() => proximo()}>
                <img src={IconNextDesativo} alt="Próximo" />
              </div>
            </div>
          </div> */}
        </TopMenu>
        <div className={desktop ? 'body' : 'body-mobile'}>
          {desktop && showMenu ? (
            <LeftMenu
              width={showSubMenu && showMenuWithSubMenu ? '18rem' : '4rem'}
              showLateralMenu={showLateralMenu}
            >
              <MenuLista
                {...{
                  desktop,
                  modulos: modulosAcessoLeft,
                  setComponentPath,
                  currentModulo,
                  currentMenu,
                  currentSubMenu,
                  showMaxMenu,
                  setShowMaxMenu,
                  showSubMenu,
                  setShowSubMenu,
                  showMenuWithSubMenu,
                  setShowMenuWithSubMenu,
                  perfilAtivo: perfil,
                  hasUnreadComunicados,
                }}
              />
              {showSubMenu && showMenuWithSubMenu && (
                <SubMenuLista
                  {...{
                    menu: showMenuWithSubMenu,
                    currentMenu,
                    subMenus: showMenuWithSubMenu?.subMenus,
                    setComponentPath,
                    currentModulo,
                    currentSubMenu,
                    showSubMenu,
                    selected: currentMenu?.id === showMenuWithSubMenu?.id,
                  }}
                />
              )}
            </LeftMenu>
          ) : (
            <LeftMenu width={'0rem'} showLateralMenu={showLateralMenu}></LeftMenu>
          )}
          <Main
            desktop={desktop}
            showSubMenu={showSubMenu}
            showSubMenuRight={showSubMenuRight}
            showMenuRight={true /*currentModulo?.menus?.length > 8*/}
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={500}
          >
            <MainScroll className="mainScroll">
              {RenderedComponent && (
                <sistemaStore.Provider
                  value={{
                    ...componentPath,
                    setComponentPath: ({ moduloPath, menuPath, subMenuPath, props }) => {
                      setComponentPath({ moduloPath, menuPath, subMenuPath, props });
                    },
                    hasUnreadComunicados,
                    setHasUnreadComunicados,
                  }}
                >
                  <RenderedComponent {...{ showMaxMenu, setShowMaxMenu, desktop }} />
                </sistemaStore.Provider>
              )}
            </MainScroll>
          </Main>
          {desktop && showMenu && true /*currentModulo?.menus?.length > 8*/ ? (
            <LeftMenu
              width={showSubMenuRight && showMenuWithSubMenuRight ? '18rem' : '4rem'}
              showLateralMenu={showLateralMenu}
            >
              {showSubMenuRight && showMenuWithSubMenuRight && (
                <SubMenuLista
                  {...{
                    menu: showMenuWithSubMenuRight,
                    currentMenu,
                    subMenus: showMenuWithSubMenuRight?.subMenus,
                    setComponentPath,
                    currentModulo,
                    currentSubMenu,
                    showSubMenu: showSubMenuRight,
                    selected: currentMenu?.id === showMenuWithSubMenuRight?.id,
                  }}
                />
              )}
              <MenuLista
                {...{
                  desktop,
                  right: true,
                  modulos: modulosAcessoTop,
                  setComponentPath,
                  currentModulo,
                  currentMenu,
                  currentSubMenu,
                  showMaxMenu,
                  setShowMaxMenu,
                  showSubMenu: showSubMenuRight,
                  setShowSubMenu: setShowSubMenuRight,
                  showMenuWithSubMenu: showMenuWithSubMenuRight,
                  setShowMenuWithSubMenu: setShowMenuWithSubMenuRight,
                  perfilAtivo: perfil,
                  hasUnreadComunicados,
                }}
              />
            </LeftMenu>
          ) : (
            <LeftMenu width={'0rem'} showLateralMenu={showLateralMenu}></LeftMenu>
          )}
        </div>
      </Content>
    </Container>
  );
}
